import { Dimensions, Platform, StyleSheet } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIPhoneDeviceWithNotchValue = PlatformUtils.isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColor,
  }),
  progressBarAndroid: { height: 2.1 },
  headerStyle: theme => ({
    height: isIPhoneDeviceWithNotchValue ? 90 : 84.2,
    paddingTop: isIPhoneDeviceWithNotchValue ? 30 : 21.8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    backgroundColor: theme.colors.backgroundColor
  }),
  touchableRefresh: theme => ({
    // flex: 1,
    // flexDirection: 'row',
    // paddingHorizontal: 16
    marginRight: 10,
    position: 'absolute',
    left: '10%',
    color: theme.colors.textColor
  }),
  touchableClose: (theme) => ({
    marginLeft: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 10,
    position: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'absolute' : null,
    right: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : null,
    color: theme.colors.textColor
  }),
  touchableBack: {
    marginRight: 10,
  },
  textHeader: theme => ({
    marginTop: 3,
    fontSize: 18.7,
    color: Colors.dark_grey,
    lineHeight: 25,
    flex: 1,
    textAlign: 'center',
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColor
  }),
});
